import { defineMessages } from 'react-intl';

export default defineMessages({
  dialogValidationButton: {
    id: 'assignment_dialog.validation_button',
  },
  dialogCancelButton: {
    id: 'assignment_dialog.cancel_button',
  },
  judiciaryExpertise: {
    id: 'expert_expertise_concerned.judiciary_expertise',
  },
  consultingExpertise: {
    id: 'expert_expertise_concerned.consulting_expertise',
  },
  back: {
    id: 'fill_expertise.back',
  },
  confirm: {
    id: 'fill_expertise.confirm',
  },
  successMessage: {
    id: 'toast.success.createExpertiseVictim.title',
  },
  consultingReport: {
    id: 'expert_expertise.tab_consulting_report.title',
  },
  noticeDeficiency: {
    id: 'expert_expertise.tab_notice_deficiency.title',
  },
  postponementsExpertise: {
    id: 'expert_expertise.tab_postponements_expertise.title',
  },
  managerActionTitle: {
    id: 'action.title',
  },
  reason: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_withdrawal_reason',
  },
  description: {
    id: 'preopening_page.claim_circumstances.description',
  },
  successToastNoticeTitle: {
    id: 'expert_expertise.toast_success.title',
  },
  successToastUpdatedNoticeTitle: {
    id: 'expert_expertise.toast_updated_success.title',
  },
  successToastPostPone: {
    id: 'expert_expertise.toast_success.postpone_expertise.title',
  },
  statusMissionPostPoneTitle: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.status',
  },
  postponeDateField: { id: 'expert_expertise.postponeDate_field' },
  comment: {
    id: 'fill_expertise.comment',
  },
  decidedBy: {
    id: 'court_manager_legal_proceedings_page.step.validator',
  },
  updateTitle: {
    id: 'legal_proceeding_page.judgement_add.civil_party.recap.edit_title',
  },
  missionDate: {
    id: 'expertise.table_header_titles.missionDate',
  },
  createdByTitle: {
    id: 'expert_expertise.created_by.title',
  },
  doesNotConcernMe: {
    id: 'expert_expertise_concerned_expertises.does_not_concern_me',
  },
  successToastRejectMission: {
    id: 'expert_expertise.toast_success.reject_assignement.title',
  },

  successDialogPrimaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.primary_button_title',
  },
  successDialogSecondaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.secondary_button_title',
  },
  successAppealAdd: {
    id: 'success_dialog.fee_note',
  },
  doNotGenerateFeeNote: {
    id: 'success_dialog.do_not_generate_fee_note',
  },
  courtFileNumberTitle: {
    id: 'expert_expertise_victim_table.court_file_number',
  },
  referenceMisionTitle: {
    id: 'expert_search_bar.mission_reference',
  },
  procedureTypeTitle: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.procedure.title',
  },
  appreciationExpertise: {
    id: 'expert_expertise_concerned.appreciation_expertise',
  },
  documentStampedTitle: {
    id: 'expert_expertise.doc_stamped.title',
  },
  noticeCreateFeeNote: {
    id: 'expert.popup_expertise.notifce.create_fee_note.title',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
});
